'use strict';
import { module } from '../app';

module.controller('speedTestCtrl', [
    '$scope', '$http', '$q', 'authService',
    function ($scope, $http, $q, authService) {
        $scope.latency = 0;
        $scope.uploadBandwidth = 0;
        $scope.downloadBandwidth = 0;
        $scope.clientInfo = [];
        $scope.clientOs = GetClientOs();
        $scope.clientBrowser = getClientBrowserVersion();
        var data = "";
        for (var i = 0; i < 3000000; i++) {
            data += "k";
        }
        var latenciesTotal = 0;
        var DownloadBandwidthTotal = 0;
        var UploadBandwidthBandwidthTotal = 0;
        $scope.benchmarkTestRan = false;

        $scope.getNetworkStats = function () {
            $scope.getLatency();

            $scope.latency = Math.round(latenciesTotal / 10);

            $scope.getDownloadBandwidth();

            $scope.getUploadBandwidth();

            saveNetworkTestResult();
        }

        $scope.getLatency = function () {
            latenciesTotal = 0;
            for (var i = 0; i < 10; i++) {
                var request = new XMLHttpRequest();

                request.open('GET', authService.currentMagViewUrl() + '/api/speedtest', false);
                var startTime = new Date().getTime();
                request.send(null);

                if (request.status === 200) {
                    var endTime = new Date().getTime()
                    latenciesTotal += endTime - startTime;
                }
            }
        }

        function saveNetworkTestResult() {
            $http.get(authService.currentMagViewUrl() + '/api/speedtest/saveNetworkTestResult?latency=' + $scope.latency + '&downloadBandwidth=' + $scope.downloadBandwidth
                + '&uploadBandwith=' + $scope.uploadBandwidth + '&clientOs=' + $scope.clientOs + '&clientBrowser=' + $scope.clientBrowser);
        }

        $scope.getDownloadBandwidth = function () {
            $scope.downloadBandwidth = 0;
            DownloadBandwidthTotal = 0;
            measureDownloadBW(10, function (e) {
                DownloadBandwidthTotal += parseInt(e);
            });
            $scope.downloadBandwidth = bytesToSize(Math.round(DownloadBandwidthTotal));
        }
        function measureDownloadBW(cnt, cb) {
            var start = new Date().getTime();
            var bandwidth;
            var i = 0;
            (function rec() {
                var xmlHttp = new XMLHttpRequest();
                xmlHttp.open('GET', authService.currentMagViewUrl() + '/api/speedtest/getDownloadBandwidth', false);

                xmlHttp.onreadystatechange = function () {
                    if (xmlHttp.readyState == 4) {
                        var x = new Date().getTime() - start;
                        var bw = Number(((10000000 / (x / 1000))));
                        bandwidth = ((bandwidth || bw) + bw) / 2;
                        i++;
                        if (i < cnt) {
                            start = new Date().getTime(); rec();
                        }
                        else cb(bandwidth.toFixed(0));
                    }
                };
                xmlHttp.send(null);
            })();

        }

        $scope.getUploadBandwidth = function () {
            $scope.uploadBandwidth = 0;
            UploadBandwidthBandwidthTotal = 0;

            measureUploadBW(10, function (e) {
                UploadBandwidthBandwidthTotal += parseInt(e);
            });
            $scope.uploadBandwidth = bytesToSize(Math.round(UploadBandwidthBandwidthTotal));
        }

        function measureUploadBW(cnt, cb) {
            var start = new Date().getTime();
            var bandwidth;
            var i = 0;
            (function rec() {
                var xmlHttp = new XMLHttpRequest();
                xmlHttp.open('POST', authService.currentMagViewUrl() + '/api/speedtest/getUploadBandwidth', false);

                xmlHttp.onreadystatechange = function () {
                    if (xmlHttp.readyState == 4) {
                        var data = JSON.parse(xmlHttp.response);
                        var endTime = data.retval;
                        var x = endTime - start;
                        var bw = Number(((3000000 / (x / 1000))));
                        bandwidth = ((bandwidth || bw) + bw) / 2;
                        i++;
                        if (i < cnt) {
                            start = new Date().getTime(); rec();
                        }
                        else cb(bandwidth.toFixed(0));
                    }
                };
                xmlHttp.send(JSON.stringify({ data: data }));
            })();

        }

        function bytesToSize(bytes) {
            const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB']
            if (bytes === 0) return 'n/a'
            const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10)
            if (i === 0) return `${bytes} ${sizes[i]})`
            return `${(bytes / (1024 ** i)).toFixed(1)} ${sizes[i]}`
        }

        function processMetricsResult(data) {

            data.forEach((item) => {
                item.Min = item.Min != 0 ? item.Min.toString().substring(0, 6) + ' ms' : '< 0.0001 ms';
                var indexOfCloseBracket = item.Name.indexOf('>')
                item.Name = item.Name.substring(1, indexOfCloseBracket);
                item.Max = item.Max.toString().substring(0, 6) + ' ms';
                item.Median = item.Median.toString().substring(0, 6) + ' ms';
                item.SpentTime = item.SpentTime.toString().substring(0, 6) + ' ms';
            });
        }

        $scope.runBenchmarkTesting = function () {
            $scope.showError = false;
            $scope.benchmarkTestRan = false;
            $http.get(authService.currentMagViewUrl() + '/api/speedtest/BenchmarkTest').then(function (result) {
                $scope.metricsList = result.data.metricsList;
                $scope.systemInfo = result.data.systemInfo;
                $scope.metricsListGathered = true;
                $scope.clientInfo = result.data.clientInfo;
                console.log($scope.clientInfo);
                processMetricsResult($scope.metricsList);
                $scope.benchmarkTestRan = true;
                saveBenchmarkResult();
            }).catch(function (data) {
                $scope.showError = true;
            });
        }

        function saveBenchmarkResult() {
            let BenchmarkTestResult = {};
            BenchmarkTestResult.clientInfo = { clientOs: $scope.clientOs, clientBrowser: $scope.clientBrowser };
            BenchmarkTestResult.systemInfo = $scope.systemInfo;
            BenchmarkTestResult.metricsList = $scope.metricsList;

            $http.post(authService.currentMagViewUrl() + "/api/speedtest/saveBenchmarkTestResult", BenchmarkTestResult);
            console.log(BenchmarkTestResult);
        }

        function GetClientOs() {
            var OSName = "Unknown OS";
            if (navigator.appVersion.indexOf("Win") != -1) OSName = "Windows";
            if (navigator.appVersion.indexOf("Mac") != -1) OSName = "MacOS";
            if (navigator.appVersion.indexOf("X11") != -1) OSName = "UNIX";
            if (navigator.appVersion.indexOf("Linux") != -1) OSName = "Linux";

            return OSName;
        }

        function getClientBrowserVersion() {
            var nVer = navigator.appVersion;
            var nAgt = navigator.userAgent;
            var browserName = navigator.appName;
            var fullVersion = '' + parseFloat(navigator.appVersion);
            var majorVersion = parseInt(navigator.appVersion, 10);
            var nameOffset, verOffset, ix;

            // In Opera, the true version is after "Opera" or after "Version"
            if ((verOffset = nAgt.indexOf("Opera")) != -1) {
                browserName = "Opera";
                fullVersion = nAgt.substring(verOffset + 6);
                if ((verOffset = nAgt.indexOf("Version")) != -1)
                    fullVersion = nAgt.substring(verOffset + 8);
            }
            // In MSIE, the true version is after "MSIE" in userAgent
            else if ((verOffset = nAgt.indexOf("MSIE")) != -1) {
                browserName = "Microsoft Internet Explorer";
                fullVersion = nAgt.substring(verOffset + 5);
            }
            // In Chrome, the true version is after "Chrome" 
            else if ((verOffset = nAgt.indexOf("Chrome")) != -1) {
                browserName = "Chrome";
                fullVersion = nAgt.substring(verOffset + 7);
            }
            // In Safari, the true version is after "Safari" or after "Version" 
            else if ((verOffset = nAgt.indexOf("Safari")) != -1) {
                browserName = "Safari";
                fullVersion = nAgt.substring(verOffset + 7);
                if ((verOffset = nAgt.indexOf("Version")) != -1)
                    fullVersion = nAgt.substring(verOffset + 8);
            }
            // In Firefox, the true version is after "Firefox" 
            else if ((verOffset = nAgt.indexOf("Firefox")) != -1) {
                browserName = "Firefox";
                fullVersion = nAgt.substring(verOffset + 8);
            }
            // In most other browsers, "name/version" is at the end of userAgent 
            else if ((nameOffset = nAgt.lastIndexOf(' ') + 1) <
                (verOffset = nAgt.lastIndexOf('/'))) {
                browserName = nAgt.substring(nameOffset, verOffset);
                fullVersion = nAgt.substring(verOffset + 1);
                if (browserName.toLowerCase() == browserName.toUpperCase()) {
                    browserName = navigator.appName;
                }
            }
            // trim the fullVersion string at semicolon/space if present
            if ((ix = fullVersion.indexOf(";")) != -1)
                fullVersion = fullVersion.substring(0, ix);
            if ((ix = fullVersion.indexOf(" ")) != -1)
                fullVersion = fullVersion.substring(0, ix);

            majorVersion = parseInt('' + fullVersion, 10);
            if (isNaN(majorVersion)) {
                fullVersion = '' + parseFloat(navigator.appVersion);
                majorVersion = parseInt(navigator.appVersion, 10);
            }

            return browserName + ' ' + majorVersion;
        }
    }]);



// WEBPACK FOOTER //
// ./src/scripts/controllers/speedTest.js